import React, { useEffect, useState, useRef } from "react";
import "./style.scss";
import { useStores } from "../../stores";

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import leftarrow from "../../assets/images/leftarrow.png";
import rightarrow from "../../assets/images/rightarrow.png";
import NoImage from "../../assets/images/noImage.jpg";
import moment from "moment";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/Header";
import notify from "../../components/Notify/notify";
import { compareAsc, format } from "date-fns";
import Slider from "react-slick";
import { Tooltip } from "react-tooltip";

const state = {
  responsive: {
    0: {
      items: 1,
    },
    450: {
      items: 1,
    },
    600: {
      items: 2,
    },
    1000: {
      items: 2,
    },
  },
};

const BookingDetail = () => {
  const location = useLocation();
  const dateRef = useRef();
  const { bookingStore } = useStores();
  const [cityId, setCityId] = useState(location?.state?.cityid);
  const [pickedDate, setPickedDate] = useState(location?.state?.pickedDate);
  const [spaceId, setSpaceId] = useState(location?.state?.id);
  const [inventoryId, setInventoryId] = useState(location?.state?.inventoryId);
  const [meetingRoomInfo, setMeetingRoomInfo] = useState("");
  const [selectedSpace, setSelectedSpace] = useState([]);
  const today = new Date();
  const date = moment(today).format("YYYY-MM-DD");
  const selectedItem = sessionStorage.getItem("selectedItem");
  const selectedSpase = sessionStorage.getItem("selectedSpase");
  const selectedDate = sessionStorage.getItem("selectedDate");
  const selectedAllSlot = sessionStorage.getItem("selectedAllSlot");

  const [selectSpaceItem, setSelectSpaceItem] = useState([]);
  const [selectInverntoryItem, setSelectInverntoryItem] = useState([]);
  let parseDate = JSON.parse(selectedDate);
  const formetedSelectdate = moment(parseDate).format("YYYY-MM-DD");
  const [selectDate, setSelectDate] = useState(formetedSelectdate);
  const [current, setCurrent] = useState(0);
  const [count, setCount] = useState(0);
  const [allSlotItem, setAllSlotItem] = useState([]);

  const [inventoryPrice, setInventoryPrice] = useState([]);
  const [selectSlotItem, setSelectedSlotItem] = useState([]);
  const [selectSlotItemLength, setSelectedSlotItemLength] = useState(0);
  const [startTime, setStartTime] = useState([]);
  const [endTime, setEndTime] = useState([]);
  const [accessKey, setAccessKey] = useState("");
  const [suggationInventry, setSuggationInventry] = useState("");
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [selectedMeetingSlots, setSelectedMeetingSlots] = useState([]);
  const [scrollFlag, setScrollFlag] = useState(true);
  const [changeDate, setDateChange] = useState(false);
  const [selectedDate2, setSelectedDate2] = useState("");
  const [accordionFirst, setAccordionFirst] = useState(false);
  const [accordionSecond, setAccordionSecond] = useState(true);
  const [accordionThird, setAccordionThird] = useState(false);
  const [carouselItem, setCarouselItem] = useState([]);
  const [showSlot, setShowSlot] = useState(false);
  let newvar = window.location.pathname;
  let access_key = newvar.split("/booking-detail/")[1];

  let navigate = useNavigate();
  // let { changeDate } = location.state;

  useEffect(() => {
    setScrollFlag(false);
  }, [scrollFlag]);

  useEffect(() => {
    getCenterList(cityId);
  }, [cityId, inventoryId]);

  useEffect(() => {
    if (selectDate == date) {
      setDateChange(false);
    } else {
      setDateChange(true);
    }
  }, [selectDate]);

  useEffect(() => {
    format(new Date(), "yyyy-MM-dd");
    const dates = [new Date(selectDate)];
    dates.sort(compareAsc);
    let datefor = dates[0];
    let tempDate = datefor.toString().split(" ");
    let formeteddate = `${tempDate[0]}, ${tempDate[2]} ${tempDate[1]}, ${tempDate[3]}`;
    setSelectedDate2(formeteddate);
  }, [selectDate]);

  useEffect(() => {
    let temp = new Date().getHours();
    let arr = [];
    let index = "";
    allSlotItem?.map((item, index) => {
      if (Number(item?.start?.split(":")[0]) >= temp) {
        arr.push({
          item,
          index,
        });
      }
    });
    index = Number(arr[0]?.index);
    setCarouselIndex(index);
  }, [carouselIndex]);

  useEffect(() => {
    setAccessKey(access_key);
  }, [window.location.pathname]);

  useEffect(() => {
    getSelectInverntoryItem();
    sessionStorage.removeItem("retryData");
  }, []);

  useEffect(() => {
    sessionStorage.setItem("selectedAllSlot", JSON.stringify(allSlotItem));
  }, [allSlotItem]);

  const getCenterList = async (city) => {
    let start_time = `${pickedDate} 00:00:00`;
    let params = `city_id=${city}${
      start_time !== 0 ? `&start_time=${start_time}` : ""
    }`;
    await bookingStore.getCenterList(params, (response) => {
      if (response?.data?.status === 1) {
        console.log(cityId, spaceId, inventoryId);
        let spaceData = response?.data?.data?.space;
        spaceData.map((item) => {
          if (item.id == spaceId) {
            setSelectedSpace(item);
            item.inventories.map((element) => {
              if (element.id == inventoryId) {
                setMeetingRoomInfo(element.meeting_room_info);
                // console.log(element, "<=====")
              }
            });
          }
        });
      } else {
        console.log("error", response.response.data.data);
        // setCenterList([]);
        // setSelecteCenter([]);
      }
    });
  };

  const getSelectInverntoryItem = () => {
    let parseData =
      selectedItem !== "undefined" &&
      selectedItem.length > 0 &&
      JSON.parse(selectedItem);
    setSelectInverntoryItem(parseData);
    let parseSpaceData =
      selectedSpase.length > 0 &&
      selectedSpase !== "undefined" &&
      JSON.parse(selectedSpase);
    setSelectSpaceItem(parseSpaceData);
    let parseSlotData =
      selectedAllSlot.length > 0 &&
      selectedAllSlot !== "undefined" &&
      JSON.parse(selectedAllSlot);

    let microsite_image = JSON.parse(parseSpaceData.microsite_image);

    let spaceimage = JSON.parse(parseData.images);

    let mergeImage = spaceimage.concat(microsite_image);

    setCarouselItem(mergeImage);

    // console.log("parseSpaceData", parseData);
    let selectedItems = [];
    parseSlotData?.map((slot) => {
      if (slot?.isSelected) {
        selectedItems.push(slot);
      }
    });
    setAllSlotItem(parseSlotData);
    setSelectedSlotItem(selectedItems);
    setSelectedSlotItemLength(selectedItems.length);

    let startTime = [...selectedItems].shift();
    let endTime = selectedItems[selectedItems.length - 1];
    setStartTime(startTime);
    setEndTime(endTime);

    getInventoryPrice(parseData, selectedItems);

    let test = document.getElementById("mapLocation");
    let text = test.getAttribute("src");
    let lat = parseSpaceData.lat;
    let long = parseSpaceData.long;
    let url = `https://maps.google.com/maps?q=${lat},${long}&z=15&output=embed`;
    test.setAttribute("src", url);
  };

  const getInventoryPrice = async (parseData, selectedItems) => {
    let selectInverntoryid = parseData?.id;
    let startTime = [...selectedItems].shift();
    let endTime = selectedItems[selectedItems.length - 1];
    let start = startTime?.start?.split(":")[0];
    let valid_from = `${selectDate}${" "}${start}:00:00`;
    let end = endTime?.end?.split(":")[0];
    let valid_upto = "";

    if (end <= 9) {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    } else {
      valid_upto = `${selectDate}${" "}${end}:00:00`;
    }
    // if (start <= 9) {
    //   valid_from = `${selectDate}${" "}0${start}:00:00`;
    // } else {
    //   valid_from = `${selectDate}${" "}${start}:00:00`;
    // }
    if (start !== undefined && end !== undefined) {
      let params = `inventory_id=${selectInverntoryid}&duration_type_id=${1}&valid_from=${valid_from}&valid_upto=${valid_upto}&access_key=${access_key}`;
      await bookingStore.inventoryPrice(params, (response) => {
        if (response?.data?.status === 1) {
          setInventoryPrice(response?.data?.data);
        } else {
          console.log("error");
        }
      });
    }
  };

  let [num, setNum] = useState(selectSlotItem.length);
  let incNum = () => {
    if (num < 24) {
      setNum(Number(num) + 1);
    }
  };
  let decNum = () => {
    if (num > 1) {
      setNum(num - 1);
    }
  };
  let handleChange = (e) => {
    setNum(e.target.value);
  };

  const getSelectedMeetingSlots = (slot, index2) => {
    let selectedmeetingarray = [];
    allSlotItem.map((item) => {
      if (item.index === slot.index) {
        let obj = item;
        if (obj.isSelected) {
          obj.isSelected = false;
          for (let i = 0; i < allSlotItem.length; i++) {
            if (allSlotItem[i].index > slot.index) {
              allSlotItem[i].isSelected = false;
            }
          }
        } else {
          obj.isSelected = true;
        }
        selectedmeetingarray.push(obj);
      } else {
        selectedmeetingarray.push(item);
      }
    });

    let arrayOfIndex = [];
    selectedmeetingarray?.map((item) => {
      if (item.isSelected) {
        arrayOfIndex.push(item.index);
      }
    });

    let check = areConsecutiveSlot(arrayOfIndex);
    if (check) {
      setAllSlotItem(selectedmeetingarray);
    } else {
      selectedmeetingarray.map((item) => {
        // if (item.index === arrayOfIndex[arrayOfIndex.length - 1]) {
        if (item.index === slot.index) {
          let obj = item;
          obj.isSelected = false;
          // selectedmeetingarray.push(obj);
        }
      });

      setAllSlotItem(selectedmeetingarray);
    }
    let selectedItems = [];
    selectedmeetingarray?.map((slot) => {
      if (slot?.isSelected) {
        selectedItems.push(slot);
      }
    });
    let startTime = [...selectedItems].shift();
    let endTime = selectedItems[selectedItems.length - 1];
    setStartTime(startTime);
    setEndTime(endTime);
    setSelectedSlotItemLength(selectedItems.length);
    setSelectedSlotItem(selectedItems);
    getInventoryPrice(selectInverntoryItem, selectedItems);
    // sessionStorage.setItem("selectedAllSlot",JSON.stringify(selectedItems.length));
    // console.log(selectedmeetingarray);
  };

  const areConsecutiveSlot = (selectedSlotArr) => {
    const sortedArr = selectedSlotArr.sort((a, b) => a - b);
    for (let i = 1; i < sortedArr.length; i++) {
      if (sortedArr[i] !== sortedArr[i - 1] + 1) {
        return false;
      }
    }
    return true;
    // var min_ele = Math.min.apply(Math, selectedSlotArr);
    // var num = 0;
    // for (var i = 0; i < selectedSlotArr.length; i++) {
    //   num = num ^ min_ele ^ selectedSlotArr[i];
    //   min_ele += 1;
    // }
    // if (num == 0) return true;
    // return false;
  };

  const bookNow = (e) => {
    e.preventDefault();
    sessionStorage.setItem("selectSpaceItem", JSON.stringify(selectSpaceItem));
    sessionStorage.setItem(
      "selectInverntoryItem",
      JSON.stringify(selectInverntoryItem)
    );
    // sessionStorage.setItem("selectedDate", JSON.stringify(date));
    sessionStorage.setItem("selectSlotItem", JSON.stringify(selectSlotItem));
    if (selectSlotItem.length > 0) {
      let url;
      if(location?.state?.searchParamsVal !== undefined){
        url=`/payment/${accessKey}?${location?.state?.searchParamsVal}` 
      }else{
        url=`/payment/${accessKey}`
      }
      navigate(
        url,

        { state: { screen: "bookingDetail", searchParamsVal: location?.state?.searchParamsVal } }
      );
    } else {
      notify("Please Select Time Slot", "danger");
      return;
    }
  };

  const getSuggationInventry = (item) => {
    sessionStorage.setItem("selectedItem", JSON.stringify(item));

    setSelectInverntoryItem(item);
    setStartTime([]);
    setEndTime([]);
    setSelectedSlotItem([]);
    setSelectedSlotItemLength([]);
    setInventoryPrice([]);
    allSlotItem?.map((slot) => {
      slot.isSelected = false;
    });
    sessionStorage.setItem("selectedAllSlot", JSON.stringify(allSlotItem));
    let microsite_image = JSON.parse(selectSpaceItem.microsite_image);

    let spaceimage = JSON.parse(item.images);

    let mergeImage = spaceimage.concat(microsite_image);

    setCarouselItem(mergeImage);
  };

  const getMeetingSlot = async (id, date) => {
    let params = `inventory_id=${
      id === "" ? selectInverntoryItem.id : id
    }&date=${date}`;
    await bookingStore.getMeetingSlot(params, (response) => {
      if (response?.data?.status === 1) {
        let responseData = response?.data?.data[0];
        setAllSlotItem(responseData.meeting_slots);
      } else {
        console.log("error");
      }
    });
  };

  const getAccordionFirst = () => {
    if (accordionFirst) {
      setAccordionFirst(false);
    } else {
      setAccordionFirst(true);
      setAccordionSecond(false);
      setAccordionThird(false);
    }
  };

  const getAccordionSecond = () => {
    if (accordionSecond) {
      setAccordionSecond(false);
    } else {
      setAccordionSecond(true);
      setAccordionThird(false);
      setAccordionFirst(false);
    }
  };

  const getAccordionThird = () => {
    if (accordionThird) {
      setAccordionThird(false);
    } else {
      setAccordionThird(true);
      setAccordionFirst(false);
      setAccordionSecond(false);
    }
  };

  const locationHighlight = (text) => {
    let split = text?.split("\n");
    // console.log(split,"<<<<split");
    split?.forEach((item) => {
      console.log(item);
    });

    return split;
  };

  var settings = {
    dots: true,
    autoplay: false,
    infinite: true,
    speed: 2000,
  };

  return (
    <>
      {scrollFlag &&
        window.scroll({
          top: 0,
          left: 0,
          behavior: "smooth",
        })}
      <Header accessKey={accessKey} queryParams={location?.state?.searchParamsVal} />
      <div className="bd-container">
        <section className="booking-listing-section">
          <div className="container mob-padding">
            <div className="row">
              <div className="col-md-12">
                <div className="banner-tag">
                  <h3 className="banner-tag-text">
                    {selectInverntoryItem.name}
                  </h3>
                </div>
                {/* <div
                  id="booking-detail"
                  class="carousel slide"
                  data-ride="carousel"
                >
                  <ul className="carousel-indicators">
                    {carouselItem?.map((item, index) => {
                      return (
                        <li
                          data-target="#booking-detail"
                          data-slide-to={index}
                          className={index === current && "active"}
                        ></li>
                      );
                    })}
                  </ul>
                  <div className="carousel-inner">
                    {/* {console.log(carouselItem, "<=====")} */}
                {/* {carouselItem.length > 0 ?
                      carouselItem?.map((item, index) => { */}

                {/* // let parseUrl = JSON.parse(item?.images)[0];
                        return (
                          <>
                            <div
                              className={
                                index === current
                                  ? "carousel-item active"
                                  : "carousel-item"
                              }
                            >
                              <img
                                src={carouselItem.length > 0 !== undefined ? item : NoImage}
                                alt="Banner 1"
                                className="banne-image"
                              />
                            </div>
                          </>
                        );
                      }) :
                      <img
                        src={NoImage}
                        alt="Banner 1"
                        className="banne-image"
                      />}
                  </div> */}
                {/* <!-- <a className="carousel-control-prev" href="#booking-detail" data-slide="prev">
                <span className="carousel-control-prev-icon"></span>
              </a>
              <a className="carousel-control-next" href="#booking-detail" data-slide="next">
                <span className="carousel-control-next-icon"></span>
              </a> --> */}
                {/* </div>  */}
                <div>
                  <Slider {...settings}>
                    {carouselItem.length > 0 ? 
                      carouselItem?.map((item, index) => {
                      console.log(item);
                      // let parseUrl = JSON.parse(item?.images)[0];
                      return (
                        <>
                          <div
                          // className={
                          //   index === current
                          //     ? "carousel-item active"
                          //     : "carousel-item"
                          // }
                          >
                            <img
                              src={item !== undefined ? item : NoImage}
                              alt="Banner 1"
                              className="banne-image"
                            />
                          </div>
                        </>
                      );
                    })
                  :
                  <div>
                    <img
                      src={NoImage}
                      alt="Banner 1"
                      className="banne-image"
                    />
                  </div>
                  }
                  </Slider>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="booking-detail-box pt-md-5 pt-4">
                  <div className="row align-items-center">
                    <div className="col-md-6  no-gutters">
                      <div className="booking-detail-box-inner">
                        <div className="seat-info">
                          <h3>{selectInverntoryItem.capacity}</h3>
                          <p>Seater</p>
                          <h4>{selectInverntoryItem.name}</h4>
                        </div>
                        <div className="booking-detail-text">
                          <h3 className="booking-detail-heading">
                            {selectSpaceItem.name}
                          </h3>
                          <p className="booking-sub-heading">
                            {selectSpaceItem.address}
                          </p>
                          <h4>
                            Rs {parseInt(selectInverntoryItem?.price)}/Hour
                          </h4>
                        </div>
                      </div>
                      <Tooltip id="my-tooltip" className="ametooltip" />
                      <div className="booking-detail-amenities-box">
                        <p className="pl-0">Amenities</p>

                        {selectInverntoryItem.amenities !== undefined &&
                          Object.entries(selectInverntoryItem?.amenities).map(
                            (value) => {
                              if (value[1] !== "") {
                                return (
                                  <img
                                    src={value[1]}
                                    className="amenities-image"
                                    data-tooltip-id="my-tooltip"
                                    data-tooltip-content={value[0]}
                                  />
                                );
                              }
                            }
                          )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="price-total-box">
                        <div className="form-row align-items-center">
                          <div className="col-md-6 col-6">
                            {/* <p className="dp-label">Duration</p> */}
                            <div
                              className="form-group icon-group mb-2"
                              onClick={() => {
                                dateRef.current.showPicker();
                              }}
                            >
                              <input
                                ref={dateRef}
                                className="form-control filter-field date"
                                value={selectDate}
                                onChange={(e) => {
                                  if (e.target.value == selectedDate) {
                                    setDateChange(false);
                                  } else {
                                    setDateChange(true);
                                  }
                                  sessionStorage.setItem(
                                    "selectedDate",
                                    JSON.stringify(e.target.value)
                                  );
                                  getMeetingSlot("", e.target.value);
                                  setSelectDate(e.target.value);
                                  setStartTime([]);
                                  setEndTime([]);
                                  setSelectedSlotItemLength([]);
                                  setSelectedSlotItem([]);
                                  setInventoryPrice([]);
                                  allSlotItem?.map((slot) => {
                                    slot.isSelected = false;
                                  });
                                }}
                                type="date"
                                min={date}
                              />
                              <span className="open-button2 ">
                                <img
                                  src={require("../../assets/images/down.png")}
                                  alt="Date"
                                  className="date-icon"
                                />
                              </span>
                              {selectDate !== "" ? (
                                <p className="date-booking">{selectedDate2}</p>
                              ) : (
                                <p className="date-booking">{"dd-mm-yyyy"}</p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6 col-6">
                            {/* <p className="dp-label">Duration</p> */}
                            <div
                              className="form-group icon-group mb-2"
                              onClick={() => {
                                setShowSlot(!showSlot);
                              }}
                            >
                              <span className="open-button2 ">
                                <img
                                  src={require("../../assets/images/down.png")}
                                  alt="Date"
                                  className="date-icon"
                                />
                              </span>
                              <p className="time-view">Time</p>
                            </div>
                          </div>
                          {/* <div className="col-md-6 pb-2">
                          <div className="Slot_btn">Time slot & Duration</div>
                          </div> */}
                        </div>
                        {showSlot && (
                          <>
                            {/* <div className="col-md-6 ml-auto">
                              <div className="row">
                                <div className="col-md-6 col-sm-6 col-6 px-0">
                                  <div className="form-group icon-group">
                                    <p className="dp-label">Time slot</p>
                                    <div className="duration-box">
                                      {startTime?.start
                                        ? `${startTime?.start} - ${endTime?.end}`
                                        : "----"}
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 col-sm-6 col-6 px-0">
                                  <p className="dp-label">Duration</p>
                                  <div className="duration-box">
                                    <div>
                                      {selectSlotItemLength != ""
                                        ? `${selectSlotItemLength} Hours`
                                        : "----"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> */}
                            <p className="listing-text pt-0">
                              Available Time Slot
                            </p>
                            <div className="slot-container">
                              <OwlCarousel
                                className="owl-theme"
                                items={11}
                                nav={true}
                                margin={0}
                                navText={[
                                  `<img src=${leftarrow} class="like-nav-left">`,
                                  `<img src=${rightarrow} class="like-nav-left">`,
                                ]}
                                key={Math.random()}
                                startPosition={changeDate ? 0 : carouselIndex}
                              >
                                {allSlotItem?.map((slot, index) => {
                                  return (
                                    <div className="item">
                                      {slot?.booking_status == 0 ||
                                      slot?.booking_status == "NA" ? (
                                        <>
                                            <a
                                              className={
                                                slot.isSelected
                                                  ? "slot-box-text disable-slot"
                                                  : changeDate
                                                  ? "slot-box-text"
                                                  : slot?.start?.split(":")[0] >
                                                    new Date().getHours()
                                                  ? "slot-box-text"
                                                  : "slot-box-text disable-slot"
                                              }
                                              onClick={() => {
                                                let temp =
                                                  new Date().getHours();
                                                if (
                                                  slot?.start?.split(":")[0] >
                                                    temp &&
                                                  !changeDate
                                                ) {
                                                  setCarouselIndex(index);
                                                  getSelectedMeetingSlots(
                                                    slot,
                                                    index
                                                  );
                                                } else if (changeDate) {
                                                  getSelectedMeetingSlots(
                                                    slot,
                                                    index
                                                  );
                                                } else {
                                                  notify(
                                                    "This slot is not available",
                                                    "danger"
                                                  );
                                                }
                                              }}
                                            >
                                              {slot.isSelected
                                                ? "x"
                                                : changeDate
                                                ? "|"
                                                : slot?.start?.split(":")[0] >
                                                  new Date().getHours()
                                                ? "|"
                                                : "x"}
                                            </a>
                                        </>
                                      ) : (
                                        <a className="slot-box-text disable-slot">
                                          x
                                        </a>
                                      )}
                                      <p className="slot-time-text">
                                        {slot?.start}
                                      </p>
                                    </div>
                                  );
                                })}
                              </OwlCarousel>
                            </div>
                          </>
                        )}
                        <div className="total-text-box">
                          <div className="total-text">
                            <h3>TOTAL</h3>
                            <h4>
                              Rs{" "}
                              {selectSlotItemLength &&
                                inventoryPrice?.base_amount}
                            </h4>
                          </div>
                          <div className="total-text-btn">
                            <a
                              href=""
                              className="book-slot-btn"
                              onClick={(e) => bookNow(e)}
                            >
                              BOOK NOW
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="feq-section">
                  <div className="row">
                    <div className="col-md-6  no-gutters">
                      <div className="faq-box">
                        <div className="accordion" id="accordionExample">
                          <div className="card faq-card">
                            <div
                              className="card-header"
                              id="headingOne"
                              data-toggle="collapse"
                              data-target="#collapseOne"
                            >
                              <h2 className="mb-0">
                                <button
                                  type="button"
                                  className="faq-btn btn btn-link"
                                  onClick={() => {
                                    getAccordionFirst();
                                  }}
                                >
                                  Location Highlights{" "}
                                  {/* <i className="fa fa-plus faq-icon"></i> */}
                                  {accordionFirst ? (
                                    <i className="fa fa-minus faq-icon"></i>
                                  ) : (
                                    <i className="fa fa-plus faq-icon"></i>
                                  )}
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapseOne"
                              className="collapse "
                              aria-labelledby="headingOne"
                              data-parent="#accordionExample"
                            >
                              <div className="card-body about-space">
                                <p className="faq-ans">
                                  {locationHighlight(
                                    selectedSpace?.location_highlight
                                  )?.map((item) => {
                                    return (
                                      <>
                                        {item} <br />
                                      </>
                                    );
                                  })}
                                  {/* {selectedSpace?.location_highlight} */}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="card faq-card">
                            <div
                              className="card-header"
                              id="headingTwo"
                              data-toggle="collapse"
                              data-target="#collapseTwo"
                              aria-expanded="true"
                            >
                              <h2 className="mb-0">
                                <button
                                  type="button"
                                  className="faq-btn btn btn-link collapsed"
                                  onClick={() => {
                                    getAccordionSecond();
                                  }}
                                >
                                  Meeting Room Highlights{" "}
                                  {accordionSecond ? (
                                    <i className="fa fa-minus faq-icon"></i>
                                  ) : (
                                    <i className="fa fa-plus faq-icon"></i>
                                  )}
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapseTwo"
                              className="collapse show"
                              aria-labelledby="headingTwo"
                              data-parent="#accordionExample"
                            >
                              <div className="card-body about-space">
                                <p className="faq-ans">
                                  {/* {meetingRoomInfo} */}
                                  {locationHighlight(meetingRoomInfo)?.map(
                                    (item) => {
                                      return (
                                        <>
                                          {item} <br />
                                        </>
                                      );
                                    }
                                  )}
                                </p>
                              </div>
                            </div>
                          </div>
                          <div className="card faq-card">
                            <div
                              className="card-header"
                              id="headingThree"
                              data-toggle="collapse"
                              data-target="#collapseThree"
                            >
                              <h2 className="mb-0">
                                <button
                                  type="button"
                                  className="faq-btn btn btn-link collapsed"
                                  onClick={() => {
                                    getAccordionThird();
                                  }}
                                >
                                  Best in Class Service{" "}
                                  {accordionThird ? (
                                    <i className="fa fa-minus faq-icon"></i>
                                  ) : (
                                    <i className="fa fa-plus faq-icon"></i>
                                  )}
                                </button>
                              </h2>
                            </div>
                            <div
                              id="collapseThree"
                              className="collapse"
                              aria-labelledby="headingThree"
                              data-parent="#accordionExample"
                            >
                              <div className="card-body about-space">
                                <p className="faq-ans">
                                  {/* {selectedSpace.service_info} */}
                                  {locationHighlight(
                                    selectedSpace.service_info
                                  )?.map((item) => {
                                    return (
                                      <>
                                        {item} <br />
                                      </>
                                    );
                                  })}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6  no-gutters">
                      <div className="map-box">
                        <iframe
                          src=""
                          id="mapLocation"
                          // src={`https://maps.google.com/maps?q=${selectSpaceItem.lat},${selectSpaceItem.long}&hl=es;z=14&amp;output=embed`}
                          width="100%"
                          height="440"
                          style={{ border: 0 }}
                          loading="lazy"
                          className="location-map"
                        ></iframe>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {selectSpaceItem?.inventories?.length !== 1 && (
          <section className="like-section">
            <h3 className="like-section-heading">You may also like</h3>
            <div className="like-section-box">
              <OwlCarousel
                className="owl-theme"
                loop
                autoplay
                smartSpeed={150}
                autoplayTimeout={3000}
                responsive={state.responsive}
                nav={true}
                margin={20}
                navText={[
                  `<img src=${leftarrow} class="like-nav-left">`,
                  `<img src=${rightarrow} class="like-nav-left">`,
                ]}
                key={Math.random()}
              >
                {selectSpaceItem?.inventories?.map((item) => {
                  return (
                    <>
                      {selectInverntoryItem.id !== item.id && (
                        <div
                          className="item"
                          onClick={() => {
                            getSuggationInventry(item);
                            getMeetingSlot(item.id, selectDate);
                            setInventoryId(item.id);
                            // window.scrollTo(0, 0, );
                            window.scrollTo({
                              top: 0,
                              left: 0,
                              behavior: "smooth",
                            });
                          }}
                        >
                          <div className="banner-tag">
                            <h3 className="likebanner-tag-text">
                              {item?.name}
                            </h3>
                          </div>
                          <img
                            src={
                              item?.images !== undefined &&
                              JSON.parse(item?.images).length > 0
                                ? JSON.parse(item?.images)[0]
                                : NoImage
                            }
                            alt="Like Banner"
                            className="like-section-image"
                          />
                          <h3 className="like-title">
                            {selectSpaceItem?.name}, {item?.capacity}
                            seater, {item?.name}
                          </h3>
                        </div>
                      )}
                    </>
                  );
                })}

                {/* 
            <div className="item">
              <div className="banner-tag">
                <h3 className="likebanner-tag-text">M 1</h3>
              </div>
              <img
                src={require("../../assets/images/image1.jpg")}
                alt="Like Banner"
                className="like-section-image"
              />
              <h3 className="like-title">
                Coworking-Raheja Titanium2, 4 Seater, M 2
              </h3>
            </div> */}
              </OwlCarousel>
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default BookingDetail;
